import React from 'react';
import './SuccessModal.css';

interface SuccessModalProps {
    isOpen: boolean;
    onClose: () => void;
    type: 'order' | 'enquiry';
}

const SuccessModal: React.FC<SuccessModalProps> = ({ isOpen, onClose, type }) => {
    if (!isOpen) return null;

    return (
        <div className="success-modal-overlay" onClick={onClose}>
            <div className="success-modal-container" onClick={(e) => e.stopPropagation()}>
                <div className="success-modal-content">
                    <div className="success-icon">✓</div>
                    <h3>Thank You!</h3>
                    <p>Our Team will Reach you out for further process ({type === 'order' ? 'Order' : 'Enquiry'})</p>
                    <button className="btn btn-primary" onClick={onClose}>
                        OK
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SuccessModal;

